import React from 'react';
import TextButton, { TextButtonProps } from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowRight from '@wix/da-ds/pkg/Icons/16x16/ArrowRight';

interface Props
  extends Omit<TextButtonProps, 'variant' | 'size' | 'postfixIcon'> {}

/**
 * A `<TextButton />` with a preset `size`, `variant`, and `postfixIcon`.
 *
 * We use this at the end of a tip.
 */
const TipButton: React.FC<Props> = props => (
  <TextButton size="small" variant="main" postfixIcon={ArrowRight} {...props} />
);
TipButton.displayName = 'TipButton';

export default TipButton;
